module.exports = __webpack_public_path__ + "img/boatmax10.55382fe7.png";